<script>
import { h } from 'vue';
import { mapState, mapActions } from 'vuex';
import steps from '../../conf/steps.json';

export default {
  // Vue 3 Upgrade: Render Function Argument
  render: () => h(),

  computed: {
    ...mapState('ui', ['isTourActive']),

    ...mapState('breakdown', ['hasLoaded']),

    isActivateTour() {
      return this.$route.query.tour !== undefined && this.hasLoaded;
    },
  },

  watch: {
    isActivateTour(isActive, wasActive) {
      if (isActive && !wasActive) {
        this.$nextTick(() => {
          const foundedTourSteps = steps
            .map((step) => {
              return {
                element: document.querySelector(`#tour-${step?.key}`),
                intro: step.value,
              };
            })
            .filter((item) => item.element);

          this.launchTour(foundedTourSteps);
        });
      }
    },

    isTourActive(isActive, wasActive) {
      if (!isActive && wasActive) {
        this.$router.push({
          ...this.$route,
          query: { ...this.$route.query, tour: undefined },
        });
      }
    },
  },

  methods: {
    ...mapActions('ui', ['launchTour']),
  },
};
</script>

<style lang="scss">
.introjs-nextbutton,
.introjs-donebutton {
  &:not(.introjs-disabled) {
    color: color(primary);
  }
}
</style>
